import { addMessages, init, } from "svelte-i18n";

import ru from '../locales/ru.json';
import en from '../locales/en.json';

addMessages('en', en);
addMessages('ru', ru);

init({
  fallbackLocale: 'ru',
  initialLocale: 'ru',
});
